/* eslint-disable no-unused-expressions */
/* eslint-disable radix */
import CustomStore from 'devextreme/data/custom_store';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from '~/services/api';
import { handleError, handleParams } from '~/services/helper';
import store from '~/store/Store';

export async function handleDeleteModulo() {
  const id = store.getState().Modulos.idModulo;
  toast.info('Excluido Módulo', { autoClose: 1000 });
  await api
    .delete(`Modulo/${id}`)
    .then(() => {
      toast.success('Módulo exluído');
    })
    .catch(() => {
      toast.error('Módulo não foi excluido, tente novamente');
    });
}

export async function handleUpdateModulo(setLoading, modulo) {
  await api
    .put('/Modulo', modulo)
    .then(() => {
      setLoading(false);
      toast.success('Dados do módulo atualizados com sucesso');
    })
    .catch(() => {
      setLoading(false);
      toast.error(
        'Ocorreu um erro durante a atualização do módulo, verifique os campos preenchidos e tente novamente'
      );
    });
}

export async function handleUpdateModuloEmpres(
  check,
  id,
  idPessoa,
  e,
  setLoading
) {
  const user = sessionStorage.getItem('@auth/userName');
  const moduloID = parseInt(store.getState().Modulos.idModulo);
  setLoading(true);
  const company = {
    id,
    idPessoaEmpresa: idPessoa,
    idModulo: moduloID,
    dataInclusao: new Date().toISOString(),
    usuario: user,
    excluido: false,
    check,
  };
  await api
    .put('/ModuloEmpresa/UpdateEmpresasModulo', company)
    .then(() => {
      check
        ? toast.success('Empresa inserida com sucesso')
        : toast.info('Empresa removida com sucesso');
      setLoading(false);
      e.component.refresh();
    })
    .catch(() => {
      toast.error(`Erro ao ${check ? 'inserir' : 'remover'} empresa`);
      setLoading(false);
      e.component.refresh();
    });
}

export async function handleRegisterModulo(modulo, setLoading, history) {
  await api
    .post('/Modulo', modulo)
    .then(() => {
      toast.success('Modulo cadastrado com sucesso :)');
      setLoading(false);
      history.push('/modulo/list');
    })
    .catch(() => {
      setLoading(false);
      toast.error('Houve um erro durante o cadastro, tente novamente');
    });
}

export async function handleDeleteMenuEspec(setLoading) {
  setLoading(true);
  const id = store.getState().Modulos.idMenu;
  toast.info('Excluindo menu...');
  await api
    .delete(`Menu?pId=${id}`)
    .then(() => {
      toast.success('Sucesso ao excluir menu');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Erro ao excluir menu, tente novamente');
    });
}

export async function handleDeleteModuloPagina(setLoading) {
  setLoading(true);
  const id = store.getState().Modulos.idPagina;
  toast.info('Excluindo página...');
  await api
    .delete(`Pagina/${id}`)
    .then(() => {
      toast.success('Sucesso ao excluir página');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Erro ao excluir página, tente novamente');
    });
}

function handleLoadModuloData(loadOptions) {
  const params = {};
  const newParams = handleParams(params, loadOptions);
  const url = `/Modulo?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

async function handleRemoveModulo(key) {
  const url = `Modulo/${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Modulo deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridModuloDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadModuloData(loadOptions),
    remove: (key) => handleRemoveModulo(key),
  }),
};

function handleLoadModuloEmpresaData(loadOptions) {
  const moduloID = store.getState().Modulos.idModulo;
  const params = {
    idModulo: moduloID,
    check: null,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `/ModuloEmpresa/GetEmpresasModulo?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

export const gridModuloEmpresaDataSource = {
  store: new CustomStore({
    key: 'idPessoa',
    load: (loadOptions) => handleLoadModuloEmpresaData(loadOptions),
  }),
};

function handleModuloMenuEspecData(loadOptions) {
  const idModulo = parseInt(store.getState().Modulos.idModulo);
  const params = {
    idModulo,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `Menu?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

async function handleRemoveModuloMenu(key) {
  const url = `Menu?pId=${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Menu deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridModuloMenuEspecDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleModuloMenuEspecData(loadOptions),
    remove: (key) => handleRemoveModuloMenu(key),
  }),
};

function handleLoadModuloPaginaData(loadOptions) {
  const idModulo = parseInt(store.getState().Modulos.idModulo);
  const params = {
    idModulo,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `Pagina?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

async function handleRemoveModuloPagina(key) {
  const url = `Pagina/${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Página deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridModuloPaginaDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadModuloPaginaData(loadOptions),
    remove: (key) => handleRemoveModuloPagina(key),
  }),
};
